import React, { Component } from "react";
import { Col } from "react-flexbox-grid";

import Paper from "material-ui-next/Paper";
import Divider from "material-ui/Divider";
import GeneralInfo from "./general-info";
import Typography from "material-ui-next/Typography";

import {
  Page,
  IconButton,
  StyledButton,
  Loadable,
  Errorable
} from "components/support";

import "./user-form.css";

class UserForm extends Component {
  constructor(props) {
    super(props);
    this.router = props.transition.router;
    this.presenter = props.presenter;
  }

  setFieldError = (field, message) => {
    this.props.viewModel.errors[field] = message;
  };

  handleFormFieldChange = ({ field, value }) => {
    this.props.viewModel.form = {
      ...this.props.viewModel.form,
      [field]: value
    };
  };

  redirectTo(target, params = {}) {
    this.router.stateService.go(target, params, {});
  }

  refreshPage() {
    window.location.reload();
  }

  handleChangePassword = () => {
    this.props.viewModel.changePassword = true;
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { title, error, loading, mode, form, errors, isNewUser } = viewModel;

    return (
      <Page>
        <Col xs={12}>
          <Typography type="display1" className="pb-sm">
            <IconButton
              icon="arrow_back"
              onClick={() => this.redirectTo("app.registration.user")}
            />
            {title}
          </Typography>
          <Errorable error={!!error} errorMessage={error}>
            <Loadable loading={loading}>
              <Paper elevation={1} className="pt-sm">
                <GeneralInfo
                  mode={mode}
                  form={form}
                  errors={errors}
                  onChangeFormField={this.handleFormFieldChange}
                  setFieldError={this.setFieldError}
                  isNewUser={isNewUser}
                  changePassword={this.handleChangePassword}
                  addAllowedCompanyUuid={uuid =>
                    presenter.addAllowedCompanyUuid(uuid)
                  }
                  removeAllowedCompanyUuid={uuid =>
                    presenter.removeAllowedCompanyUuid(uuid)
                  }
                />

                <Divider className="mt-sm" />

                <div className="text-right p-sm">
                  <StyledButton
                    label="Cancelar"
                    onClick={() => this.redirectTo("app.registration.user")}
                    flat
                  />
                  <StyledButton
                    primary
                    label="Salvar Usuário"
                    onTouchTap={() => this.presenter.userSalesman()}
                  />
                </div>
              </Paper>
            </Loadable>
          </Errorable>
        </Col>
      </Page>
    );
  }
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/user-form.view.jsx